import { useQuery } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

export function useProjectSummariesQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project", project.id, "summaries"],
        queryFn: async () => {
            const res = await apiClient.getProjectSummaries({
                params: {
                    projectId: project.id,
                },
            });
            if (res.status !== 200) {
                throw new Error("failed to fetch project summaries");
            }
            return res.body;
        },
    });
}
